/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Current status of the consumer.
 * @export
 */
export const ConsumerStatus = {
    Active: 'ACTIVE',
    Disabled: 'DISABLED'
} as const;
export type ConsumerStatus = typeof ConsumerStatus[keyof typeof ConsumerStatus];


export function instanceOfConsumerStatus(value: any): boolean {
    for (const key in ConsumerStatus) {
        if (Object.prototype.hasOwnProperty.call(ConsumerStatus, key)) {
            if (ConsumerStatus[key as keyof typeof ConsumerStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ConsumerStatusFromJSON(json: any): ConsumerStatus {
    return ConsumerStatusFromJSONTyped(json, false);
}

export function ConsumerStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConsumerStatus {
    return json as ConsumerStatus;
}

export function ConsumerStatusToJSON(value?: ConsumerStatus | null): any {
    return value as any;
}

export function ConsumerStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): ConsumerStatus {
    return value as ConsumerStatus;
}

